// GENERAL
import routes from "language/general/routes.js";
import weekDay from "language/general/weekDay.js";
// VIEW
import cart from "language/view/cart.js";
import shippingAddress from "language/view/shippingAddress.js";
import contacts from "language/view/contacts.js";
import payment from "language/view/payment.js";
import menuList from "language/view/menuList.js";
import userInformation from "language/view/userInformation.js";

const resources = {
  lng: "it",
  resources: {
    en: {
      translation: {
        // GENERAL
        routes: routes.en.translation,
        weekDay: weekDay.en.translation,
        // VIEW
        cart: cart.en.translation,
        shippingAddress: shippingAddress.en.translation,
        contacts: contacts.en.translation,
        payment: payment.en.translation,
        menuList: menuList.en.translation,
        userInformation: userInformation.en.translation,
        // BASIC
        change_language: "Language",
        language_it: "ITA",
        language_en: "EN",
        today: "Today",
        tomorrow: "Tomorrow",
        change_currency: "Currency",
        take_away: "Take-away",
        delivery: "Delivery",
        bath_house: "Bathhouse",
        reserve_table: "Reserve table",
        allergens: "Allergens",
        legend: "Legend",
        from: "from",
        no_data_select: "No data select",
        //
        select_date_title: "Select date",
        select_date_description: "",
        readMore: "Read more",
        readLess: "Read less",
        information: "About the museum:",
        eventInformation: "About the event:",
        date: "Date",
        time: "Time",
        location: "Address:",
        selectData: "Select data",
        selectTime: "Select time",
        loading: "loading...",
        noResults: "Non ci sono orari disponibili",
        backToMuseum: "Back to museum",
        backToList: "Back to events",
        confirmedReservation: "Reservation completed",
        bookAnEvent: "Book an Event",
        bookEvent: "Registration form",
        noEventMessage: "There are no scheduled events",
        only: "Only",
        oneLeft: "seat available",
        fewLeft: "seats available",
        placesCompleted: "Places completed",
        areStillAvailable: "Places are still available for the dates:",
        allPlaces: "All places for the event ",
        of: "on",
        areCompleted: "are completed.",
        eventClosed: "Reservations are closed at the moment",
        tickets: "Buy Tickets",
        buyEntranceTickets: "Buy tickets for visiting the museum",
        events: "Events",
        buyEventsTickets: "Buy tickets for the museum's events",
        lastDay: "Attention! You can buy the tickets for the last day only: ",
        cartFull:
          "You have reached the maximum number of tickets purchasable in a single session",
        soldOutEvent: "SOLD OUT EVENT",
      },
    },
    it: {
      translation: {
        // GENERAL
        routes: routes.it.translation,
        weekDay: weekDay.it.translation,
        // VIEW
        cart: cart.it.translation,
        shippingAddress: shippingAddress.it.translation,
        contacts: contacts.it.translation,
        payment: payment.it.translation,
        menuList: menuList.it.translation,
        userInformation: userInformation.it.translation,
        // BASIC
        change_language: "Lingua",
        language_it: "ITA",
        language_en: "EN",
        today: "Oggi",
        tomorrow: "Domani",
        change_currency: "Valuta",
        take_away: "Asporto",
        delivery: "Consegna",
        bath_house: "Stabilimento balneare",
        reserve_table: "Riserva tavolo",
        allergens: "Allergeni",
        legend: "Legenda",
        from: "a partire da",
        no_data_select: "Nessuna data selezionata",
        //
        select_date_title: "Seleziona una data",
        select_date_description: "",
        readMore: "Leggi di più",
        readLess: "Leggi meno",
        information: "Informazioni sul museo:",
        eventInformation: "Descrizione evento:",
        date: "Data",
        time: "Orario",
        location: "Indirizzo:",
        selectData: "Seleziona data",
        selectTime: "Seleziona ora",
        loading: "loading...",
        noResults: "Non ci sono orari disponibili",
        backToMuseum: "Torna al museo",
        backToList: "Torna agli eventi",
        bookAnEvent: "Prenota un evento",
        bookEvent: "Modulo di prenotazione",
        confirmedReservation: "Prenotazione effettuata",
        noEventMessage: "Nessun evento in programma",
        only: "Solo",
        oneLeft: "posto disponibile",
        fewLeft: "posti disponibili",
        placesCompleted: "Posti terminati",
        areStillAvailable: "Sono ancora disponibili posti per le date:",
        allPlaces: "Tutti i posti per l'evento",
        of: "del",
        areCompleted: "sono terminati.",
        eventClosed: "Le prenotazioni sono chiuse al momento",
        tickets: "Biglietti",
        buyEntranceTickets: "Acquista biglietti per l'ingresso al museo",
        events: "Eventi",
        buyEventsTickets: "Acquista biglietti per gli eventi del museo",
        lastDay:
          "Attenzione! Puoi comprare biglietti solo per l'ultimo giorno disponibile: ",
        cartFull:
          "Hai raggiunto il numero massimo di biglietti acquistabili contemporaneamente",
        soldOutEvent: "EVENTO SOLD OUT",
      },
    },
  },
};

export default resources;
